import React from 'react'
import usePopUp from './use-popup'
import propTypes from 'prop-types'

export default function OpenPopUpOnClick ({ children, toggle = true }) {
  const { setActive, setReferenceElement } = usePopUp()

  const handleClick = () => {
    if (!toggle) {
      return setActive(true)
    }
    return setActive(oldActive => !oldActive)
  }

  return (
    <>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          onClick: handleClick,
          ref: setReferenceElement
        })
      )}
    </>
  )
}

OpenPopUpOnClick.propTypes = {
  /**
   * Determines whether the onClick should also close the popUp when clicked after it has been opened.
   */
  toggle: propTypes.bool,
  /**
   * The button that recieves the OnClick handler.
   */
  children: propTypes.any
}
